var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-form-decorator",
    {
      attrs: {
        id: _vm.id,
        title: _vm.title,
        helpText: _vm.helpText,
        error: _vm.error,
        hasError: _vm.hasError,
        required: _vm.required,
        value: _vm.value,
        hidden: _vm.hidden,
        errorLocales: _vm.errorLocales,
      },
    },
    [
      _c(
        "div",
        { staticClass: "ak-relation", attrs: { "data-relation-id": _vm.id } },
        [
          _vm.currentRelation.selected.length
            ? _c(
                "draggable",
                {
                  staticClass: "ak-relation__selected",
                  attrs: { disabled: !_vm.currentRelation.enableSorting },
                  model: {
                    value: _vm.currentRelation.selected,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentRelation, "selected", $$v)
                    },
                    expression: "currentRelation.selected",
                  },
                },
                [
                  _c(
                    "transition-group",
                    {
                      attrs: {
                        type: "transition",
                        name: "flip-list",
                        tag: "div",
                      },
                    },
                    _vm._l(_vm.selectedItems, function (item, key) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "ak-relation__selected-item",
                        },
                        [
                          _vm.currentRelation.enableSorting
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "ak-relation__selected-item-drag-handle",
                                },
                                [_c("ak-icon-button", [_vm._v("drag_handle")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ak-relation__selected-values",
                              class: {
                                "ak-relation__selected-values--first":
                                  !_vm.currentRelation.enableSorting,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ak-relation__selected-prop" },
                                [
                                  item.widget
                                    ? _c(
                                        "ak-widget",
                                        {
                                          attrs: {
                                            slot: item.widget.slot,
                                            type: item.widget.type,
                                            attributes: Object.assign(
                                              {},
                                              item.widget.attributes,
                                              { id: item.widget.id }
                                            ),
                                            callbacks: item.widget.callbacks,
                                            objectId: item.id,
                                            contextType: "grid-cell",
                                            callbackUri:
                                              "/" +
                                              _vm.currentRelation.foreignList
                                                .bundle +
                                              "/" +
                                              _vm.currentRelation.foreignList
                                                .id +
                                              "/",
                                          },
                                          slot: item.widget.slot,
                                        },
                                        [
                                          _vm._l(
                                            item.widget.slot,
                                            function (slot) {
                                              return _c(
                                                "template",
                                                { slot: slot.type },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(slot.value) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _c("span", [_vm._v(_vm._s(item.entry))]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                item.widgets.addOns,
                                function (widget, widgetKey) {
                                  return _c(
                                    "div",
                                    {
                                      key: widget.id + "-" + key,
                                      staticClass: "ak-relation__selected-prop",
                                    },
                                    [
                                      _c(
                                        "ak-widget",
                                        {
                                          attrs: {
                                            slot: widget.slot,
                                            type: widget.type,
                                            attributes:
                                              _vm.addOnWidgetAttributes(
                                                widget,
                                                widget.id,
                                                item
                                              ),
                                            callbacks: widget.callbacks,
                                            objectId: item.id,
                                            contextType: "grid-cell",
                                            callbackUri:
                                              "/" +
                                              _vm.currentRelation.foreignList
                                                .bundle +
                                              "/" +
                                              _vm.currentRelation.foreignList
                                                .id +
                                              "/",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleWidgetInput(
                                                widget.id,
                                                item,
                                                $event
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.validateAddOnValue(
                                                widget.id,
                                                item.addOnValues,
                                                item
                                              )
                                            },
                                          },
                                          slot: widget.slot,
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                item.addOnValues[widgetKey]
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              !_vm.enableForeignList
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ak-relation__selected-item-edit",
                                    },
                                    [
                                      _c(
                                        "ak-icon-button",
                                        {
                                          attrs: {
                                            href: _vm.editSelectedUrl(item.id),
                                          },
                                        },
                                        [_vm._v("edit")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ak-relation__selected-item-delete",
                            },
                            [
                              _c(
                                "ak-icon-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.enableForeignList
                                        ? _vm.deleteSelected(item.id)
                                        : _vm.openDeleteDialog(item.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            delete\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ak-button",
            {
              staticClass: "ak-relation__select-button",
              attrs: { outlined: true, size: "small" },
              on: {
                click: function ($event) {
                  _vm.$router.push(_vm.relationUrl())
                },
              },
            },
            [
              !_vm.currentRelation.selected.length && _vm.enableForeignList
                ? _c(
                    "span",
                    {
                      directives: [
                        { name: "translate", rawName: "v-translate" },
                      ],
                    },
                    [_vm._v("Selecteren")]
                  )
                : !_vm.enableForeignList
                ? _c(
                    "span",
                    {
                      directives: [
                        { name: "translate", rawName: "v-translate" },
                      ],
                    },
                    [_vm._v("Toevoegen")]
                  )
                : _c(
                    "span",
                    {
                      directives: [
                        { name: "translate", rawName: "v-translate" },
                      ],
                    },
                    [_vm._v("Wijzigen")]
                  ),
            ]
          ),
          _vm._v(" "),
          _vm.renderRelationResolver
            ? _c("ak-stock-relation-resolver", {
                attrs: {
                  relationString: _vm.currentRelationString,
                  relationReference: _vm.relationReference,
                  defaultIdsSelected: _vm.selectedIds,
                  enableForeignList: _vm.enableForeignList,
                  filterOrderId: _vm.filterOrderId,
                },
                on: {
                  close: _vm.triggerClose,
                  updateRelations: _vm.updateRelations,
                  refresh: _vm.updateRelations,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("ak-modal", {
        attrs: {
          "max-width": "350",
          title: _vm.$t("Bent u zeker dat u dit item wilt verwijderen?"),
          confirmText: _vm.$t("Verwijderen"),
          cancelText: _vm.$t("Annuleren"),
        },
        on: {
          onCancel: function ($event) {
            _vm.deleteDialog = false
            _vm.deleteDialogItemId = null
          },
          onConfirm: function ($event) {
            _vm.deleteSelected(_vm.deleteDialogItemId)
            _vm.deleteDialog = false
            _vm.deleteDialogItemId = null
          },
        },
        model: {
          value: _vm.deleteDialog,
          callback: function ($$v) {
            _vm.deleteDialog = $$v
          },
          expression: "deleteDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }